<span
    class="copy"
    [matTooltip]="tooltip"
    role="button"
    tabindex="0"
    [attr.aria-label]="'copyToClipboard.copyToClipboard' | transloco"
    (click)="copyToClipboard()"
    (keydown.enter)="copyToClipboard()"
    (keydown.space)="$event.preventDefault(); copyToClipboard()">
    <mat-icon color="primary">content_copy</mat-icon>
</span>